import React from "react";
import { Box } from "@mui/material";
import { COLORS } from "../../theme/tokens";

export const COMBO_IMAGE_ACCEPT = ".jpg,.jpeg,.png,image/jpeg,image/png";

const ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];

/** True when the picked file is a jpg/jpeg/png, matching what the API accepts. */
export const isAllowedComboImage = (file) => {
  if (!file) return false;
  if (ALLOWED_TYPES.includes(file.type)) return true;
  // Some browsers leave `type` empty — fall back to the extension.
  return /\.(jpe?g|png)$/i.test(file.name || "");
};

/**
 * One labelled combo picture slot (preview + file input), used for both the
 * display image and the dimension image in Add/Update Combo.
 */
const ComboImageField = ({ label, hint, previewSrc, onFileChange }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
    <Box
      sx={{
        fontSize: "11.5px",
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: COLORS.textMuted,
      }}
    >
      {label}
    </Box>
    <Box
      sx={{
        width: 210,
        height: 150,
        border: `1px solid ${COLORS.cardBorder}`,
        borderRadius: "6px",
        background: "#F7F8F9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "14px",
        boxSizing: "border-box",
      }}
    >
      <img
        src={previewSrc}
        alt={label}
        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
      />
    </Box>
    <input type="file" onChange={onFileChange} accept={COMBO_IMAGE_ACCEPT} />
    <Box sx={{ fontSize: "11.5px", color: COLORS.textFaint, lineHeight: 1.5 }}>
      {hint}
    </Box>
  </Box>
);

export default ComboImageField;
